module.exports = __webpack_public_path__ + "img/reward-1.1d1b9ae6.png";